export const setCurrentClusterInstanceId = (
  { commit }: { commit: any },
  id?: string
) => {
  commit("SET_CURRENT_CLUSTER_INSTANCE_ID", id);
};

export const setSearchPrefix = (
  { commit }: { commit: any },
  prefix?: string
) => {
  commit("SET_SEARCH_PREFIX", prefix);
};
